import { createFileRoute, redirect } from "@tanstack/react-router";
import { allSchoolsQueryOptions } from "../../../../../../api/useAllSchools";
import SchoolDetailsPage from "../../../../../../pages/Admin/Organizations/SchoolDetailsPage/SchoolDetailsPage";

export const Route = createFileRoute(
  "/(app)/admin/organizations/$organizationId/schools/$schoolId"
)({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const data = await context.queryClient.ensureQueryData(
      allSchoolsQueryOptions
    );

    const school = data.map.get(Number(params.schoolId));

    if (school && school.OrganizationID.toString() !== params.organizationId) {
      throw redirect({
        to: "/admin/organizations/$organizationId/schools/$schoolId",
        params: {
          organizationId: school.OrganizationID.toString(),
          schoolId: params.schoolId,
        },
      });
    }
  },
});

function RouteComponent() {
  const { organizationId, schoolId } = Route.useParams();
  return (
    <SchoolDetailsPage
      organizationId={Number(organizationId)}
      schoolId={Number(schoolId)}
    />
  );
}
